import { type UseQueryResult, useQuery } from 'react-query';
import { ReportAreaService } from '@wealthlane/api-services/wealthlane-report-service';

const useGetReportArea = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const reportAreaList = useQuery(
    ['getReportArea'],
    async () => {
      return await handleRequest(ReportAreaService.getApiReportApiAppReportAreaReportAreas());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return reportAreaList;
};

export default useGetReportArea;
